import React, { useEffect, useState } from "react";
import "../component/style.css";
import SideNav from "../component/sideNav";
import Header from "../component/header";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { MediaApi } from "../apis";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  Tooltip,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InsightsIcon from "@mui/icons-material/Insights";
import EditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Grid from "@mui/material/Grid2";
import CustomInput from "../component/customInput";
import CustomInputLabel from "../component/customInputLabel";
import { CopyAll } from "@mui/icons-material";

const Media = () => {
  const [Medias, setMedias] = useState([]);
  const [paginator, setPaginator] = useState({
    page: 0,
    perPage: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [displayViewModal, setDisplayViewModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const MediaRouter = MediaApi();

  // Attributes
  const [name, setName] = useState("");
  const [fileType, setFileType] = useState("select");
  const [file, setFile] = useState(null); // Uploaded file
  const [preview, setPreview] = useState(null); // File preview

  const [searchTerm, setSearchTerm] = useState("");

  //Err Attributes
  const [nameErr, setNameErr] = useState("");

  const columns = [
    {
      field: "name",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Name
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.name,
      sortable: false,
    },
    {
      field: "url",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          File
        </div>
      ),
      flex: 1,
      renderCell: (params) => {
        const fileUrl = params?.value;
        if (!fileUrl) return <div className="file-container">No File</div>;

        const fileExtension = fileUrl.split(".").pop().toLowerCase();

        return (
          <div className="fileBox">
            {["png", "jpg", "jpeg", "gif"].includes(fileExtension) ? (
              <img src={fileUrl} alt="Uploaded File" className="file-image" />
            ) : ["mp4", "webm", "ogg"].includes(fileExtension) ? (
              <video className="file-video" controls>
                <source src={fileUrl} type={`video/${fileExtension}`} />
                Your browser does not support the video tag.
              </video>
            ) : fileExtension === "pdf" ? (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="file-pdf"
              >
                View PDF
              </a>
            ) : (
              <div className="file-unsupported">Unsupported Format</div>
            )}
          </div>
        );
      },
      sortable: false,
    },
    {
      field: "type",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          FileType
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.type,
      sortable: false,
    },
    {
      field: "createdAt",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Created At
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => {
        const dateString = row?.updatedAt;
        if (!dateString) return "";
        const dateObject = new Date(dateString);
        const formattedDate = dateObject.toISOString().split("T")[0];

        return formattedDate;
      },
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 200,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Preview" placement="top">
              <InsightsIcon style={{ color: "green", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Detail"
          onClick={() => {
            setSelectedRecord(row);
            toggleViewModal();
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Copy URL" placement="top">
              <CopyAll style={{ color: "gray", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Copy_URL"
          onClick={() => {
            const val = row?.url;
            navigator.clipboard.writeText(val);
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Edit" placement="top">
              <EditIcon style={{ color: "#27326A", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Edit"
          onClick={() => {
            setSelectedRecord(row);
            setName(row?.name);
            setFileType(row?.fileType);
            toggleEditModal();
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete" placement="top">
              <DeleteIcon style={{ color: "red", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Delete"
          onClick={() => {
            toggleDeleteModal();
            setSelectedRecord(row?._id);
          }}
        />,
      ],
    },
  ];

  useEffect(() => {
    getAllMedias();
    // eslint-disable-next-line
  }, [paginator]);

  const toggleAddModal = () => setDisplayAddModal(!displayAddModal);
  const toggleEditModal = () => setDisplayEditModal(!displayEditModal);
  const toggleViewModal = () => setDisplayViewModal(!displayViewModal);
  const toggleDeleteModal = () => setDisplayDeleteModal(!displayDeleteModal);

  const getAllMedias = async ({ type = "" } = {}) => {
    try {
      const res = await MediaRouter.getAllPaginated({
        page: paginator.page,
        pageSize: paginator.pageSize,
        type: type,
      });
      if (res?.data) {
        setMedias(res?.data);
        setTotalCount(res?.pagination?.totalCount);
      }
    } catch (error) {
      console.log("Medias ", error);
    }
  };

  const addMedia = () => {
    setName();
    setFileType();
    setNameErr("");
    toggleAddModal();
  };

  const createMedia = async () => {
    try {
      const isValid = validate();
      if (!isValid) return null;

      const submitData = new FormData();

      submitData.append("name", name);
      submitData.append("type", fileType);
      if (file) {
        submitData.append("url", file);
      }
      setLoader(true);
      const res = await MediaRouter.create(submitData);
      if (res.status !== 201 && res.status !== 200) {
        const msg =
          res?.error?.response?.data?.message || "An unknown Error occured";
        alert(msg);
      } else {
        toggleAddModal();
        setLoader(false);
        setName("");
        setFileType("");
        setFile("");
        setPreview("");
        getAllMedias();
      }
    } catch (error) {
      console.log("Medias ", error);
    }
  };

  const removeMedia = async () => {
    try {
      const id = selectedRecord;
      const res = await MediaRouter.remove(id);
      if (res) {
        getAllMedias();
        toggleDeleteModal();
      }
    } catch (error) {
      console.log("Medias ", error);
    }
  };

  const validate = () => {
    let isValid = true;
    if (!name) {
      setNameErr("name is required");
      isValid = false;
    }

    if (!fileType) {
      alert("File Type is Required");
      isValid = false;
    }

    return isValid;
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debounceSearch = debounce(getAllMedias, 500);

  const handleSearchInput = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    debounceSearch({ search });
  };

  const handleFileOption = (e) => {
    setFileType(e.target.value);
    setFile(null);
    setPreview(null);
  };

  const handleFileUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    const allowedFormats = {
      IMAGE: ["image/png", "image/jpeg", "image/jpg", "image/gif"],
      VIDEO: ["video/mp4", "video/webm", "video/ogg"],
      PDF: ["application/pdf"],
    };

    if (!allowedFormats[fileType]?.includes(uploadedFile.type)) {
      alert(`Invalid file format. Please upload a valid ${fileType} file.`);
      return;
    }

    if (preview) {
      URL.revokeObjectURL(preview);
    }

    // Rename the uploaded file
    const fileExtension = uploadedFile.name.split(".").pop(); // Extract the original extension
    const renamedFile = new File([uploadedFile], `${name}.${fileExtension}`);
    setFile(renamedFile);

    // Handle PDF Preview
    if (fileType === "PDF") {
      const maxFileSize = 5 * 1024 * 1024; // 5MB limit
      if (renamedFile.size > maxFileSize) {
        alert("PDF file is too large. Please upload a smaller file.");
        return;
      }

      const pdfUrl = URL.createObjectURL(renamedFile);
      setPreview(pdfUrl);
      return;
    }

    // Generate Preview for Images and Videos
    if (fileType === "IMAGE") {
      const reader = new FileReader();
      reader.onload = () => setPreview(reader.result);
      reader.readAsDataURL(renamedFile);
    } else if (fileType === "VIDEO") {
      const videoUrl = URL.createObjectURL(renamedFile);
      setPreview(`${videoUrl}#${Date.now()}`);
    }
  };

  const fileOption = ["IMAGE", "VIDEO", "PDF"];

  return (
    <>
      <div className="mainContainer">
        {/* Add Dialog */}
        <Dialog open={displayAddModal} onClose={toggleAddModal}>
          <DialogTitle>Create Media</DialogTitle>
          <DialogContent sx={{ maxWidth: "500px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <CustomInput
                  id="name"
                  name="name"
                  title="Enter name"
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameErr("");
                  }}
                  required={nameErr.length > 0 ? true : false}
                  helperText={nameErr}
                  placeholder="enter name"
                  width="100%"
                />
                <CustomInputLabel title={"File Type"} />
                <Select
                  id="select"
                  value={fileType}
                  onChange={handleFileOption}
                  variant="outlined"
                  displayEmpty
                  sx={{ width: "100%" }}
                  renderValue={(selected) =>
                    selected ? selected : "Select File type"
                  }
                >
                  <MenuItem value="">Select File Type</MenuItem>
                  {fileOption.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>

                {fileType && (
                  <CustomInputLabel
                    title={
                      fileType ? `${fileType} File` : "Select a file type first"
                    }
                  />
                )}
                {/* Preview Section */}
                {fileType && (
                  <div className="uploadMediaBox">
                    {fileType === "IMAGE" && preview && (
                      <img src={preview} alt="Preview" />
                    )}
                    {fileType === "VIDEO" && preview && (
                      <video controls>
                        <source
                          src={preview}
                          type={file?.type || "video/mp4"}
                        />
                        Your browser does not support the video tag.
                      </video>
                    )}
                    {fileType === "PDF" && preview && (
                      <iframe
                        src={preview}
                        width="200"
                        height="300"
                        title="PDF Preview"
                      ></iframe>
                    )}
                  </div>
                )}
                {/* upload button & input  */}
                {fileType && (
                  <div className="imgBox">
                    <input
                      type="file"
                      accept={
                        fileType === "IMAGE"
                          ? "image/*"
                          : fileType === "VIDEO"
                          ? "video/*"
                          : fileType === "PDF"
                          ? "application/pdf"
                          : ""
                      }
                      onChange={handleFileUpload}
                      style={{ display: "none" }}
                      id="fileUpload"
                    />
                    <button
                      onClick={() => {
                        setPreview("");
                        setFile("");
                        document.getElementById("fileUpload").click();
                      }}
                    >
                      Upload {fileType}
                    </button>
                  </div>
                )}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            {loader && (
              <div className="sm_loader">
                <div className="ring"></div>
                <img src="./images/Logos/flash.svg" alt="logo"></img>
              </div>
            )}
            <Button
              onClick={toggleAddModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => createMedia()}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>

        {/* View Dialog */}
        <Dialog open={displayViewModal} onClose={toggleViewModal}>
          <DialogTitle>Preview Media</DialogTitle>
          <DialogContent sx={{ maxWidth: "500px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <CustomInputLabel title={"Name"} isRequired={false} />
                <TextField
                  value={selectedRecord?.name}
                  fullWidth
                  disabled
                  variant="outlined"
                  sx={{ backgroundColor: "#E9ECEF" }}
                />
                <CustomInputLabel title={"File Type"} isRequired={false} />
                <TextField
                  value={selectedRecord?.type}
                  fullWidth
                  disabled
                  variant="outlined"
                  sx={{ backgroundColor: "#E9ECEF" }}
                />

                <CustomInputLabel
                  title={`${selectedRecord?.type} File`}
                  isRequired={false}
                />
                {/* Preview Section */}

                <div className="uploadMediaBox">
                  {selectedRecord?.type === "IMAGE" && (
                    <img src={selectedRecord?.url} alt="Preview" />
                  )}
                  {selectedRecord?.type === "VIDEO" && (
                    <video controls>
                      <source
                        src={selectedRecord?.url}
                        type={file?.type || "video/mp4"}
                      />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {selectedRecord?.type === "PDF" && (
                    <iframe
                      src={selectedRecord?.url}
                      width="200"
                      height="300"
                      title="PDF Preview"
                    ></iframe>
                  )}
                </div>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleViewModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog open={displayDeleteModal} onClose={toggleDeleteModal}>
          <DialogTitle>DELETE Media</DialogTitle>
          <DialogContent>
            Are you sure you want to disable/delete this Media?
            <h3 className="infoAlert">
              *All details will be lost and can not be recovered
            </h3>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeleteModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => removeMedia()}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Delete Media
            </Button>
          </DialogActions>
        </Dialog>

        <Header></Header>
        <SideNav active="Media" />
        <div className="contentBox">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1%",
              marginTop: "1%",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <TextField
              label="Search"
              margin="dense"
              variant="outlined"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "25ch" }}
              onChange={handleSearchInput}
              value={searchTerm}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon></SearchIcon>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#27326A",
                width: "148px",
                height: "40px",
                textTransform: "none",
              }}
              onClick={() => addMedia()}
            >
              <AddCircleOutlineIcon
                sx={{ marginRight: "10px", width: 18, height: 18 }}
              />
              Add Media
            </Button>
          </Box>
          <DataGrid
            sx={{
              borderRadius: 3,
              border: 0,
              width: "100%",
              outline: "none", // Remove blue outline
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold !important",
                overflow: "visible !important",
                color: "#27326A",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none", // Remove blue outline
                },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none", // Remove blue outline
              },
              "& .MuiDataGrid-cell": {
                outline: "none", // Remove blue outline from cells
              },
              "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left",
              },
              "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center",
              },
              "& .MuiDataGrid-cell--textRight": {
                textAlign: "right",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "white",
                boxShadow: "0px 0px 30px #EDEEF4",
                outline: "none",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                outline: "none",
              },
              "& .name-cell-style": {
                color: "#566477",
                outline: "none",
              },
              "& .default-cell-style": {
                color: "#95A2B4",
                outline: "none",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none",
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {},
            }}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row._id}
            columns={columns}
            rows={Medias}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterExcludeHiddenColumns: true,
                },
              },
              pagination: {
                paginationModel: { page: 0, pageSize: paginator.perPage },
              },
            }}
            paginationMode="server"
            rowCount={totalCount}
            onPaginationModelChange={(newPage) => {
              setPaginator({
                page: newPage?.page,
                perPage: newPage?.pageSize,
              });
            }}
            pageSizeOptions={[10]}
          ></DataGrid>
        </div>
      </div>
    </>
  );
};

export default Media;
